// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"c233c126","105":"5ce8db38","466":"bcb457d9","508":"706ce0bf","671":"2c70d661","780":"9d7fa284","883":"75d182f8","966":"5bd6a574"}[chunkId] + ".chunk.js";
};